type UrlCollection = {
  [key: string]: string[]
}

let baseUrls: UrlCollection
let serviceUrls: UrlCollection

const getServiceLookupUrl = () =>
  `https://service-lookup.${
    process.env.APP_ENV === "production" ? "izettle" : "izettletest"
  }.com`

export const fetchBaseUrls = async () => {
  return fetch(`${getServiceLookupUrl()}/baseurls`)
    .then((response) => response.json())
    .then((data) => {
      baseUrls = data
    })
}

export const fetchServiceUrls = async (accessToken: string) => {
  return fetch(`${getServiceLookupUrl()}/serviceurls`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
    .then((response) => response.json())
    .then((data) => {
      serviceUrls = data
    })
}

export const getBaseUrls = () => baseUrls
export const getServiceUrls = () => serviceUrls
